import React from 'react';
import { IonIcon } from '@ionic/react';
import { alertCircleOutline, trashOutline, checkmarkCircleOutline } from 'ionicons/icons';

export type ConfirmDialogVariant = 'danger' | 'warning' | 'info';

interface ConfirmDialogProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: ConfirmDialogVariant;
  icon?: string;
  isLoading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const VARIANT_STYLES: Record<ConfirmDialogVariant, { iconBg: string; iconColor: string; defaultIcon: string; btnClass: string }> = {
  danger: {
    iconBg: '#fef2f2',
    iconColor: '#ef4444',
    defaultIcon: trashOutline,
    btnClass: 'form-btn form-btn--danger',
  },
  warning: {
    iconBg: '#fffbeb',
    iconColor: '#d97706',
    defaultIcon: alertCircleOutline,
    btnClass: 'form-btn form-btn--primary',
  },
  info: {
    iconBg: '#eef2ff',
    iconColor: '#5e81f4',
    defaultIcon: checkmarkCircleOutline,
    btnClass: 'form-btn form-btn--primary',
  },
};

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  isOpen,
  title,
  message,
  confirmLabel = 'Confirmă',
  cancelLabel = 'Anulează',
  variant = 'danger',
  icon,
  isLoading = false,
  onConfirm,
  onCancel,
}) => {
  if (!isOpen) return null;

  const vs = VARIANT_STYLES[variant];

  return (
    <div className="logout-overlay" onClick={() => { if (!isLoading) onCancel(); }}>
      <div className="logout-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="logout-dialog__icon" style={{ background: vs.iconBg, color: vs.iconColor }}>
          <IonIcon icon={icon ?? vs.defaultIcon} />
        </div>
        <h3 className="logout-dialog__title">{title}</h3>
        <p className="logout-dialog__text">{message}</p>
        <div className="logout-dialog__actions">
          <button
            className="form-btn form-btn--secondary"
            onClick={onCancel}
            disabled={isLoading}
          >
            {cancelLabel}
          </button>
          <button
            className={vs.btnClass}
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading && <span className="login-spinner" style={{ width: 14, height: 14, borderWidth: 2 }} />}
            {isLoading ? 'Se procesează...' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
